import {useLocation, useNavigate} from 'react-router-dom';
import React, {ReactElement, useEffect} from 'react';
import {useAccount, useIsAuthenticated} from "@azure/msal-react";

type AuthenticationGuardProps = {
    children: ReactElement;
}

export const AuthenticationGuard = ({children}: AuthenticationGuardProps) => {
    const isAuthenticated = useIsAuthenticated();
    const account = useAccount();
    const {pathname} = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const isPublicPath = ['/auth', '/logout', '/401', '/403', '/declarations/verify'].includes(pathname) || pathname.startsWith('/declarations/verify/');
        if (!isAuthenticated && !isPublicPath && !account) {
            navigate('/auth');
        }
    }, [isAuthenticated, account, navigate]);

    if (!isAuthenticated) return null;

    return <>{children}</>;
};

export default AuthenticationGuard;
